module.exports = __webpack_public_path__ + "img/snow.b96c57fa.jpg";